import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: yuanruili
 * id F7613EF8-368F-4AA6-B833-7246A01C3961
 * name arm-flex
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arm-flex.svg
 * tags
 */
export const ArmFlexIcon = createSvgIcon(<><path d="M3 18.34C3 18.34 4 7.09 7 3L12 4L11 7.09H9V14.25H10C12 11.18 16.14 10.06 18.64 11.18C21.94 12.71 21.64 17.32 18.64 19.36C16.24 21 9 22.43 3 18.34Z" /></>, 'ArmFlexIcon');
export default ArmFlexIcon